import React from 'react';
import ConfiguredDashboardPage from './ConfiguredDashboardPage';
import { graphComponentRegistry } from './reportRegistry';
import { DashboardFiltersStorageKeyProvider } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/DashboardFiltersStorageKeyContext';
import { resolvePageFiltersConfig } from 'src/mtska-frontend-modules/modules/_shared/dashboardFilters/resolvePageFiltersConfig';

const withFiltersStorageProvider = (component, filtersStorageKey) => {
    if (filtersStorageKey === undefined || filtersStorageKey === null || filtersStorageKey === '') {
        return component;
    }

    return (
        <DashboardFiltersStorageKeyProvider value={filtersStorageKey}>
            {component}
        </DashboardFiltersStorageKeyProvider>
    );
};

const keyOf = (prefix, ...parts) => [prefix, ...parts].filter(Boolean).join('-');

export const resolveBiIntegratedReport = ({
    t,
    filters,
    keyPrefix = 'biint',
    filtersStorageKey,
    sectionIds,
    reportConfiguration,
}) => {
    const allSections = reportConfiguration?.report?.sections || [];
    const sections = Array.isArray(sectionIds) && sectionIds.length > 0
        ? allSections.filter((section) => sectionIds.includes(section.id))
        : allSections;

    return sections.map((section) => ({
        id: section.id,
        title: t(section.label || section.title),
        icon: section.icon,
        requiredPrivileges: section.requiredPrivileges || [],
        pages: (section.pages || []).map((page) => {
            const pageFiltersConfig = resolvePageFiltersConfig(reportConfiguration, page.filterSetKey);
            const filterCatalog = reportConfiguration?.filters || {};
            const pageDataProviderName = page.dataProviderName || section.dataProviderName;
            const pageKey = keyOf(keyPrefix, section.id, page.id);
            const sectionTitle = t(section.title || section.label || '');
            const pageLabel = t(page.label || page.title || '');
            const pageTitle = (
                <>
                    {pageLabel ? <span>{pageLabel}</span> : null}
                    {sectionTitle ? (
                        <span
                            style={{
                                opacity: 0.5,
                                marginLeft: pageLabel ? '0.35em' : undefined,
                            }}
                        >
                            {sectionTitle}
                        </span>
                    ) : null}
                </>
            );

            const pageComponent = (
                <ConfiguredDashboardPage
                    page={page}
                    pageTitle={pageTitle}
                    dataProviderName={pageDataProviderName}
                    defaultFilters={filters}
                    pageFiltersConfig={pageFiltersConfig}
                    filterSetName={page.filterSetKey}
                    filterCatalog={filterCatalog}
                    graphComponentRegistry={graphComponentRegistry}
                    pageKey={pageKey}
                />
            );

            return {
                id: page.id,
                title: pageLabel,
                icon: page.icon,
                requiredPrivileges: page.requiredPrivileges || [],
                component: withFiltersStorageProvider(pageComponent, filtersStorageKey),
            };
        }),
    }));
};

export const getBiIntegratedReportTitle = (reportConfiguration) => reportConfiguration?.report?.title || 'Business Intelligence';
